import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type HubSpotInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type HubSpotInboundContactSyncSettings = {
  autoSync: boolean
  filters: HubSpotInboundContactSyncSettingsFilters
}

export type HubSpotInboundSyncSettings = {
  contact: HubSpotInboundContactSyncSettings
}

export type HubSpotSettingsFormValues = {
  inbound: HubSpotInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const hubSpotSettingsDefaultValues: HubSpotSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}
